module.exports = __webpack_public_path__ + "static/media/financial-strength-pie-chart-numbered.5a84d54e.svg";